'use client';

import { EXIST_LOCAL_STORAGE } from '@/services/constants';
import { baseURL } from '@/services/constants/app';
import { getBrowserName, getExactPath, getPlatform, getStorage, setStorage } from '@/services/helperFunctions';
import { getIp, makeSiteAnalytics } from '@/services/simpleApis';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

export default function AnalyticsClientEffect() {
    useEffect(() => {
        const site_visitor_id = uuidv4();
        const pagePath = getExactPath(location.pathname);
        const handleBeforeUnload = () => {
            const exitBody = {
                site_visitor_id,
                exit_page: pagePath,
            };
            navigator.sendBeacon(`${baseURL}/SiteAnalytics/Analytics`, new Blob([JSON.stringify(exitBody)], { type: 'application/json' }));
        };

        // Init analytics
        setStorage('lastVisitedISIN', '');
        setStorage('scrollLength', '0');
        sessionStorage.setItem('is_bounced', 'true');
        setStorage(EXIST_LOCAL_STORAGE.SITE_VISITOR_ID, site_visitor_id);

        const user_id = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
        const browser = getBrowserName();
        const device = getPlatform();

        getIp().then((data) => {
            const body = {
                site_visitor_id,
                user_id,
                browser,
                device,
                country: data.country_name,
                ip_address: data.ip,
            };
            makeSiteAnalytics(body);
        });

        // Attach unload
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return null;
}
